import { request } from "../@utils";
import { requestFile } from "../@utils";
const selfDelivery = {
    // 创建自提点
    mallSelfDeliveryCreate: async (params) => {
        const res = await request.post("/mallSelfDelivery/create", { data: params });
        return res;
    },
    // 删除自提点
    mallSelfDeliveryDelete: async (params) => {
        const res = await request.post(`/mallSelfDelivery/delete`, { data: params });
        return res;
    },
    // 查询自提点详情
    mallSelfDeliveryDetail: async (id) => {
        const res = await request.get(`/mallSelfDelivery/detail/${id}`);
        return res;
    },
    // 分页查询自提点列表
    mallSelfDeliveryList: async (params) => {
        const res = await request.post("/mallSelfDelivery/list", { data: params });
        return res;
    },
    // 获取可用的自提点列表
    mallSelfDeliveryListByStoreCode: async (params) => {
        const res = await request.post("/mallSelfDelivery/listByStoreCode", { data: params });
        return res;
    },
    // 编辑自提点
    mallSelfDeliveryUpdate: async (params) => {
        const res = await request.post("/mallSelfDelivery/update", { data: params });
        return res;
    },
    // 启用/禁用自提点
    mallSelfDeliveryUpdateStatus: async (params) => {
        const res = await request.post("/mallSelfDelivery/updateStatus", { data: params });
        return res;
    },
};
export default selfDelivery;